import Vue from 'vue';
import VueRouter from 'vue-router';
Vue.use(VueRouter);
import homeRouter from './modules/home.js';
import specialTopicRouter from './modules/specialTopic.js';
export const constantRoutes = [
	homeRouter,
	specialTopicRouter,
	// 通配符路由-需要在最后
	{
		path: '*',
		redirect: (to) => {
			console.log(to);

			// 判断逻辑
			return '/'; // 默认重定向首页
		},
	},
	// {
	//   path: "/login",
	//   component: () => import("@/views/login/index"),
	//   hidden: true
	// },
	// {
	//   path: "/register",
	//   name: "register",
	//   component: () => import("@/views/register/index"),
	//   hidden: true
	// },
	// {
	//   path: "/404",
	//   component: () => import("@/views/404"),
	//   hidden: true
	// },
	// {
	//   path: "/home",
	//   name: "home",
	//   meta: { title: "首页" },
	//   component: () => import("@/views/home/index"),
	//   hidden: true
	// },
	// {
	//   path: "/",
	//   component: Layout,
	//   redirect: "/home",
	//   hidden: true
	// },
	// 404 page must be placed at the end !!!
	// { path: "*", redirect: "/404", hidden: true }
];
export const asyncRoutes = [homeRouter];
const createRouter = () =>
	new VueRouter({
		mode: 'history', // require service support
		scrollBehavior: () => ({ y: 0 }),
		routes: constantRoutes,
	});

const router = createRouter();
// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
	const newRouter = createRouter();
	router.matcher = newRouter.matcher; // reset router
}
// ✅ 核心：捕获路由懒加载的 ChunkLoadError
router.onError((error) => {
	// 判断是否是代码分片加载失败
	if (error.message.includes('ChunkLoadError')) {
		console.warn('路由懒加载失败，自动刷新获取最新代码');
		// 强制刷新页面（拉取最新的路由/代码）
		window.location.reload();
	}
});
export default router;
